import React from "react";
import { useNavigate } from "react-router-dom";

interface CreateNewAgentCardProps {
  onClick?: () => void;
}

const CreateNewAgentCard: React.FC<CreateNewAgentCardProps> = ({ onClick }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      navigate("/create-agent");
    }
  };

  return (
    <div
      className="group flex h-full min-h-[300px] cursor-pointer flex-col items-center justify-center rounded-xl border-2 border-dashed border-theme-border p-6 transition-all hover:border-brand-primary/50 hover:bg-theme-secondary/10"
      onClick={handleClick}
    >
      <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-theme-primary/15 transition-transform group-hover:scale-110">
        <span className="material-icons-outlined text-3xl text-brand-primary">
          add
        </span>
      </div>
      <h3 className="mb-2 text-lg font-bold text-theme-fg">Create New Agent</h3>
      <p className="max-w-[200px] text-center text-sm text-theme-fg-muted">
        Configure a new AI assistant with custom tools and settings.
      </p>
    </div>
  );
};

export default CreateNewAgentCard;
